import { Injectable } from '@angular/core';

import {
  IPoderCalorifico,
  IPoderCalorificoPost,
} from '@/app/core/interfaces/calorific-power.interface';
import { AppSettings } from '@/app/core/utils/app.settings';
import { HttpService } from '@/app/core/services/http/http.service';

import { ADMIN_SERVICES } from '@/app/core/const/http.const';

@Injectable({
  providedIn: 'root',
})
export class CalorificPowerService {
  calorificPower: IPoderCalorifico[];
  constructor(
    private http: HttpService,
    private appSetting: AppSettings
  ) {}

  async getAllCalorificPower(): Promise<IPoderCalorifico[]> {
    if (this.calorificPower) {
      return this.calorificPower;
    } else {
      return await this.updateLocalCalorificPower();
    }
  }

  async updateLocalCalorificPower(): Promise<IPoderCalorifico[]> {
    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.CALORIFIC_POWER}`;
    this.calorificPower = (await this.http.getService(
      url
    )) as IPoderCalorifico[];
    return this.calorificPower;
  }

  async createUpdateCalorificPower(data: IPoderCalorificoPost, uuid?: string) {
    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.CALORIFIC_POWER}`;
    try {
      const res = uuid
        ? await this.http.putService(`${url}/${uuid}`, data)
        : await this.http.postService(url, data);
      return { res, status: true };
    } catch (err) {
      return { err, status: false };
    }
  }

  async deleteCalorificPower(uuid: string) {
    const url: string = `${this.appSetting.adminURL}/${ADMIN_SERVICES.CALORIFIC_POWER}/${uuid}`;
    try {
      await this.http.deleteService(url);
      return true;
    } catch {
      return false;
    }
  }
}
